<template>
  <context-page :title="$t('administration.reviewSystemUsers')">
      <VueTabulator id="userManagmentTable" ref="tabulator" v-model="data" :options="tabulatorOptions" />
  </context-page>
</template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/context-page/ContextPage'
import tabulatorMixin from '@/mixins/tabulator'

export default {
  name: 'user-management',
  components: {
    ContextPage
  },
  mixins: [tabulatorMixin],
  data: function () {
    return {
      UserStatus: {
        ACTIVE: 1,
        INACTIVE: 2,
        DISABLED: 3
      },
      data: [],
      loader: false,
      loading: false,
      tabulatorOptions: {
        ajaxURL: Vue.$config.api_root_internal + '/' + Vue.$apiConfig.pagedUsersInformationGet,
        columns: [
          { title: 'id', field: 'id', visible: false },
          { title: this.$t('general.nameAndSurname'), align: 'center', field: 'name', headerFilter: this.vTextFieldFilter, headerFilterLiveFilter: false },
          { title: this.$t('general.email'), align: 'center', field: 'login', headerFilter: this.vTextFieldFilter, headerFilterLiveFilter: false },
          {
            title: this.$t('administration.localUserRoles'),
            align: 'center',
            field: 'roleId',
            formatter: (cell, formatterParams, onRendered) => {
              const role = cell.getValue()
              return this.$t('roles.' + role)
            },
            headerFilter: this.vStatusSelect,
            headerFilterParams: { items: [this.$t('roles.1'), this.$t('roles.2'), this.$t('roles.3'), this.$t('roles.4')] },
            headerFilterLiveFilter: false
          },
          {
            title: this.$t('administration.userStatus'),
            align: 'center',
            field: 'status',
            formatter: (cell, formatterParams, onRendered) => {
              const status = cell.getValue()
              if (status === this.UserStatus.ACTIVE) {
                return '<span class="status-active-span">' + this.$t('systemUserStatuses.' + status) + '</span>'
              } else if (status === this.UserStatus.INACTIVE) {
                return '<span class="status-inactive-span">' + this.$t('systemUserStatuses.' + status) + '</span>'
              }

              return '<span class="status-revoked-span">' + this.$t('systemUserStatuses.' + status) + '</span>'
            },
            headerFilter: this.vStatusSelect,
            headerFilterParams: { items: [this.$t('systemUserStatuses.1'), this.$t('systemUserStatuses.2'), this.$t('systemUserStatuses.3')] },
            headerFilterLiveFilter: false
          }
        ],
        rowClick: (e, row) => {
          this.$router.push({ name: 'user-details', params: { userId: row.getData().id } })
        }
      }
    }
  }
}
</script>
